import media from "cssMix/index"
import styled from "styled-components"

export default styled.div`
  font-size: 30px;
  font-weight: 600;
  color: #ffffff;
  text-align: center;
  .smallText {
    font-size: 20px;
    font-weight: normal;
    color: #888d9f;
    margin-top: 16px;
  }
  ${media.tablet`
    font-size:24px;

    .smallText{
        font-size:18px;
    }
`}
  ${media.mobile`
    font-size:18px;

    .smallText{
      font-size:16px;

    }
    `}
`
